import { ApolloError, WatchQueryFetchPolicy } from '@apollo/client';
import { useMemo } from 'react';
import companySettingDefaults from '../../shared/defaultSettings/defaultCompanySettings';
import { GetCompanySettingQuery, GetCompanySettingQueryResult, useGetCompanySettingQuery } from '../api';

type UseCompanySettingResult = {
    companySetting: Omit<
        GetCompanySettingQuery['companySetting'],
        '_id' | 'settingId' | 'lastUpdate' | 'logoUrl' | 'faviconUrl'
    >;
    loading: boolean;
    error?: ApolloError;
    refetch: GetCompanySettingQueryResult['refetch'];
};

const useCompanySetting = (fetchPolicy: WatchQueryFetchPolicy = 'cache-first'): UseCompanySettingResult => {
    const { data, loading, error, refetch } = useGetCompanySettingQuery({ fetchPolicy });

    return useMemo(
        () => ({
            companySetting: data?.companySetting ?? companySettingDefaults,
            loading,
            error: error ?? undefined,
            refetch,
        }),
        [data?.companySetting, loading, error, refetch]
    );
};

export default useCompanySetting;
